import { AuthController } from "@somewear/auth";
import { RenderIf } from "@somewear/ui";
import type { IErrorLoading } from "@web/common/Common";
import * as Common from "@web/common/Common";
import type ControlledInputController from "@web/common/ControlledInputController";
import ControlledInputViewRegex from "@web/common/ControlledInputViewRegex";
import * as React from "react";

import * as LandingCommon from "./LandingCommon";

interface IProps extends IErrorLoading {
	verifyController: ControlledInputController;
	verifyCode(): void;
	hideSignOut?: boolean;
}

const VerifyView: React.FunctionComponent<IProps> = (props: IProps) => (
	<div className="mx-2 w-full md:w-auto md:min-w-96">
		<LandingCommon.CenterHeader text="LET'S VERIFY YOUR PHONE NUMBER" />
		<div className="px-10">
			<LandingCommon.ErrorMessage error={props.error} />
			<LandingCommon.FirstInput error={props.error}>
				<ControlledInputViewRegex
					exclude={/\D/}
					controlledInput={props.verifyController}
					value={props.verifyController.getValue()}
					maxSize={6}
					placeholder="XXXXXX"
					className="font-normal mb-2.5 w-full !max-w-full rounded border border-gray-600 bg-transparent h-14 p-5 text-center tracking-[5px]"
				/>
			</LandingCommon.FirstInput>
			<Common.CenterContent>
				<LandingCommon.Button onClick={props.verifyCode}>
					<Common.TitleButtonText>VERIFY</Common.TitleButtonText>
				</LandingCommon.Button>
			</Common.CenterContent>
			<RenderIf condition={!props.hideSignOut}>
				<Common.CenterContent>
					<div className="text-sm tracking-wide fixed bottom-12 text-blue-500 cursor-pointer">
						<span
							onClick={() => {
								AuthController.service.signOut$().subscribe();
							}}
						>
							{" "}
							LOGOUT
						</span>
					</div>
				</Common.CenterContent>
			</RenderIf>
		</div>
	</div>
);

export default VerifyView;
